import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import getClassNameFactory from "../../utilities/classNames";
import PropTypes from "prop-types";
import React from "react";
import SandwichContentItem from "./components/SandwichContentItem";
import classNames from "classnames";

var Sandwich = function Sandwich(_ref) {
  var alignMiddle = _ref.alignMiddle,
      children = _ref.children,
      layoutVariant = _ref.layoutVariant,
      leadItems = _ref.leadItems,
      media = _ref.media;
  var getClassName = getClassNameFactory(Sandwich.displayName);
  var cleanLayoutVariant = layoutVariant.replace(/,/g, "");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames(_defineProperty({
        alignMiddle: alignMiddle
      }, cleanLayoutVariant, true))
    })
  }, leadItems ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "lead"
    })
  }, leadItems.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: getClassName({
        descendantName: "leadItem"
      })
    }, item);
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "media"
    })
  }, media), children ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
  }, children) : null);
};

Sandwich.layoutVariants = ["content-3/5,media-2/5", "media-2/5,content-3/5", "content-1/3,media-2/3", "media-2/3,content-1/3"];
Sandwich.displayName = "Sandwich";
/* eslint-disable max-len */

Sandwich.propTypes = {
  /**
   * Align content to the middle, vertically
   */
  alignMiddle: PropTypes.bool,

  /**
   * Content, typically a RichText component along with a link or a group
   */
  children: PropTypes.node.isRequired,

  /**
   * Layout variant modifier (Default: "content-3/5,media-2/5")
   */
  layoutVariant: PropTypes.oneOf(Sandwich.layoutVariants),

  /**
   * Leading components
   */
  leadItems: PropTypes.array.isRequired,

  /**
   * Media Component
   */
  media: PropTypes.node.isRequired
};
Sandwich.defaultProps = {
  layoutVariant: "content-3/5,media-2/5"
};
/* eslint-enable max-len */

Sandwich.ContentItem = SandwichContentItem;
export default Sandwich;